import { Listing, ListingPopularityItem } from "@t/Listing"
import { fetchRest } from "@lib/fetchRest"
import moment from "moment"

export type HotDealsResponse = {
    results: Listing[]
    pagination: {
        page: number
        pageCount: number
    }
}
export async function getHotDeals(queryString: string, signal?: AbortSignal): Promise<HotDealsResponse> {
    try {
        const res = await fetch(`/api${queryString}`, {
            method: "GET",
            signal,
            headers: {
                "Content-Type": "application/json"
            }
        })
        return await res.json()
    } catch (e) {
        console.warn(e)
    }
    return { results: [], pagination: { page: 1, pageCount: 0 } }
}

export async function getHotDealsPopularity({ id, time }: { id: number; time: number }) {
    const result = {
        views: 0,
        favorites: 0
    }
    try {
        const res = await fetchRest<{ items: ListingPopularityItem[] }>(`listing-popularities/${id}`, {
            fields: ["id"],
            populate: {
                items: {
                    pagination: {
                        limit: 100
                    },
                    filters: {
                        day: {
                            $gte: moment().subtract(time, "days").valueOf()
                        }
                    }
                }
            }
        })
        const items = Array.isArray(res?.data?.items) ? res.data.items : []
        items.forEach((i) => {
            result.views += i.views
            result.favorites += i.favorites
        })
        return result
    } catch (e) {
        console.warn(e)
    }
    return result
}
